import { FormControlLabel, Switch, SwitchProps } from '@mui/material';

interface PermissionToggleProps {
  label: string;
  checked: boolean;
  onChange: SwitchProps['onChange'];
  disabled?: boolean;
  testIdPrefix?: string;
  testIdSuffix?: string;
}

export const PermissionToggle = ({
  label,
  checked,
  onChange,
  disabled = false,
  testIdPrefix = '',
  testIdSuffix = '',
}: PermissionToggleProps) => {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          data-testid={`${testIdPrefix ? `${testIdPrefix}-` : ''}permission-toggle${testIdSuffix ? `-${testIdSuffix}` : ''}`}
        />
      }
      label={label}
    />
  );
};
